import { TAuthConverter } from '../types/converter.types';
import { TQuestionDB, TQuestionUI, TVideoLinkDB, TVideoLinkUI } from '../types/faq.types';

export const videoLinkConverter: TAuthConverter<TVideoLinkUI, TVideoLinkDB, TVideoLinkUI, TVideoLinkDB> = {
  toDb: (data) => {
    return {
      id: data.id,
      title: data.title,
      videoUrl: data.url,
    };
  },
  fromDb: (data) => {
    return {
      id: data.id,
      title: data.title,
      url: data.videoUrl,
    };
  },
};

export const questionConverter: TAuthConverter<TQuestionUI, TQuestionDB, TQuestionUI, TQuestionDB> = {
  toDb: (data) => {
    return {
      id: data.id,
      question: data.question,
      answer: data.answer,
    };
  },
  fromDb: (data) => {
    return {
      id: data.id,
      question: data.question,
      answer: data.answer,
    };
  },
};

export const videoLinksListConverter: TAuthConverter<TVideoLinkUI[], TVideoLinkDB[], TVideoLinkUI[], TVideoLinkDB[]> = {
  toDb: (data) => {
    return (data ?? []).map(videoLinkConverter.toDb);
  },
  fromDb: (data) => {
    return (data ?? []).map(videoLinkConverter.fromDb);
  },
};

export const questionsListConverter: TAuthConverter<TQuestionUI[], TQuestionDB[], TQuestionUI[], TQuestionDB[]> = {
  toDb: (data) => {
    return (data ?? []).map(questionConverter.toDb);
  },
  fromDb: (data) => {
    return (data ?? []).map(questionConverter.fromDb);
  },
};
